const faqs = [
  {
    question: "Does Indiana have its own passport agency?",
    answer:
      "Indiana has one regional passport agency: the Chicago Passport Agency (230 S Dearborn St Suite 380, Chicago IL 60604). It is the only regional passport agency in the entire state — Fort Wayne, Evansville, South Bend, and all other Indiana cities must travel to Indianapolis to access it in person. This gives Northwest Indiana travelers a unique local advantage. The nearest alternative for northern Indiana is the Chicago Passport Agency.",
  },
  {
    question: "How fast can I get a passport in Indiana?",
    answer:
      "With Fast Passport Center's courier service, Indiana travelers can receive a passport in as little as 24 hours. Our standard expedited service ranges from 3 to 9 business days. Routine processing through the post office typically takes 6 to 13 weeks. Given Indiana's popularity for spring break Caribbean travel and Indy 500 international fans, expedited services are especially popular in the Indianapolis metro, Carmel, Fishers, and Fort Wayne areas.",
  },
  {
    question: "What makes Northwest Indiana the best area in Indiana for passports?",
    answer:
      "Northwest Indiana cities like Gary, Hammond, and Valparaiso are the closest Indiana communities to a regional passport agency (230 S Dearborn St Suite 380, Chicago IL 60604). This means Gary, Hammond, and Valparaiso residents have the fastest access to emergency passport service in the state — just 30–40 minutes from Chicago.",
  },
  {
    question: "Do I need to visit a passport acceptance facility in Indiana?",
    answer:
      "First-time applicants, minors under 16, and those replacing lost or stolen passports must visit an acceptance facility (typically a post office, county clerk, or library). Indiana has acceptance facilities in all major cities and many smaller communities. Renewals for adults with a passport issued within the last 15 years can usually be done by mail without an in-person visit.",
  },
  {
    question: "Can I use the Chicago Passport Agency from Indiana?",
    answer:
      "Yes. For Northwest Indiana residents in Gary, Hammond, and Valparaiso, the Chicago Passport Agency (230 S. Dearborn St, Chicago, IL 60604) is only 30–40 minutes away — significantly closer than Indianapolis. Fort Wayne residents may also find Chicago comparable to Indianapolis depending on traffic. Fast Passport Center always routes your documents to the fastest available agency.",
  },
  {
    question: "What airport do most Indiana travelers use for international flights?",
    answer:
      "Indianapolis International Airport (IND) is the primary airport for Central Indiana. IND offers direct flights to Toronto, Cancun, and Paris (seasonal) plus connecting service worldwide through Atlanta (ATL), Chicago (ORD), and Dallas (DFW). The airport is only 7 miles from downtown Indianapolis and 25 minutes from Carmel.",
  },
  {
    question: "Can I renew my passport by mail in Indiana?",
    answer:
      "Yes — if your most recent passport was issued when you were 16 or older, was issued within the last 15 years, is undamaged, and was issued in your current name (or you have legal documentation of a name change), you can renew by mail using Form DS-82. Mail your application to the National Passport Processing Center. For faster service, use an approved expedited courier like Fast Passport Center.",
  },
  {
    question: "How do Evansville travelers get emergency passports?",
    answer:
      "Evansville residents must travel approximately 3 hours northeast to the Chicago Passport Agency or approximately 4 hours north to the Chicago Passport Agency for in-person emergency service. Fast Passport Center's courier service eliminates this drive entirely — we hand-deliver your documents to whichever agency has the fastest available appointment.",
  },
];

export default function IndianaFAQSection() {
  return (
    <section id="faq" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">FAQ</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Indiana Passport Questions
          </h2>
          <p className="text-gray-500 text-base leading-relaxed">
            Quick answers for travelers applying for passports across the Hoosier State.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, i) => (
            <details
              key={i}
              className="group bg-white rounded-lg border border-gray-200 overflow-hidden"
            >
              <summary className="flex items-center justify-between cursor-pointer p-5 list-none">
                <span className="font-bold text-[#1A365D] text-sm pr-4">{faq.question}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                  <i className="ri-add-line text-[#1A365D] text-sm group-open:ri-subtract-line"></i>
                </div>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-gray-500 text-sm leading-relaxed">{faq.answer}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}